export default __webpack_public_path__ + "static/media/server-status-bg.668e72c0.png";